export enum KeyboardKey {
	V = 'v',
	C = 'c',
	Delete = 'Delete',
	Escape = 'Escape',
}
